import { render } from "./page-buyingpower.vue?vue&type=template&id=6d46ec0a"
import script from "./page-buyingpower.js?vue&type=script&lang=js"
export * from "./page-buyingpower.js?vue&type=script&lang=js"

import "./page-buyingpower.vue?vue&type=style&index=0&id=6d46ec0a&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__